import { sha256 } from '@noble/hashes/sha256';
import { bytesToHex, utf8ToBytes } from '@noble/hashes/utils';
import { v4 } from 'uuid';

// Browser-safe drop-in for the `aguid` package, which needs Node's `crypto`
// (webpack polyfilled it; browsers and Vite have none). Output is identical:
// no seed gives a random v4 UUID; a seed gives the same SHA-256-derived ID
// `aguid` did, which matters because seeded IDs (see getIdentifier) can be
// persisted.
const aguid = (seed?: string | number | { toString: () => string }): string => {
  if (!seed) {
    return v4();
  }

  const chars = bytesToHex(sha256(utf8ToBytes(seed.toString())))
    .substring(0, 36)
    .split('');
  chars[8] = '-';
  chars[13] = '-';
  chars[14] = '4';
  chars[18] = '-';
  chars[19] = '8';
  chars[23] = '-';
  return chars.join('');
};

export default aguid;
